// 27 server settings:

// export const api = "https://onespace27.fabmediatech.com/api";
// export const botapi = "https://api.fabmediatech.com:447";
// export const rcsbaseurl = "https://onespace27.fabmediatech.com/rcsapi/api";
// export const customerapi = "https://onespace27.fabmediatech.com/api";
// export const whatsappapi = "https://onespace27.fabmediatech.com/whatsapp";
// export const emailapi = "https://onespace27.fabmediatech.com/bulkemail/api";


// Production settings:

export const botapi = "https://api.fabmediatech.com:447";
export const api = "https://onespace.fabmediatech.com/api";
export const customerapi = "https://onespace.fabmediatech.com/api";
export const rcsbaseurl = "https://onespace.fabmediatech.com/rcsapi/api";
export const whatsappapi = "https://onespace.fabmediatech.com/whasupapi";
export const emailapi = "https://onespace.fabmediatech.com/emailapi";


// Localhost settings:
// export const api = "http://localhost:9000/api";
// export const botapi = "https://api.fabmediatech.com:447";
// export const rcsbaseurl = "http://localhost:9001/api";
// export const customerapi = "http://localhost:9000/api";
// export const whatsappapi = "https://wa.fabmediatech.com/";
// export const emailapi = "http://localhost:9002/api";
